import { UserType } from '~/utils/enum'
import pluginDetail from 'pages/plugin/pluginDetail.vue'
import sortDetail from 'pages/plugin/sortDetail.vue'

const Plugin = [
  {
    name: 'PluginDetail',
    path: '/pluginDetail/:id',
    component: pluginDetail,
    meta: {
      title: '插件详情'
    }
  },
  {
    name: 'SortDetail',
    path: '/sortDetail/:id',
    component: sortDetail,
    meta: {
      title: '分类详情',
      keepAlive: true
    }
  },
  {
    name: 'CreatePlugin',
    path: '/createPlugin',
    component: () => import('pages/plugin/createPlugin'),
    meta: {
      title: '发布插件',
      rols: [UserType.Developer, UserType.Admin, UserType.StationMaster],
      keepAlive: true
    }
  },
  {
    name: 'UpdatePlugin',
    path: '/updatePlugin/:id',
    component: () => import('pages/plugin/updatePlugin'),
    meta: {
      title: '修改插件',
      rols: [UserType.Developer, UserType.Admin, UserType.StationMaster],
      keepAlive: true
    }
  },
  {
    name: 'CreateVersion',
    path: '/createVersion/:id',
    component: () => import('pages/plugin/createVersion'),
    meta: {
      title: '更新插件版本',
      rols: [UserType.Developer, UserType.Admin, UserType.StationMaster],
      keepAlive: true
    }
  },
  {
    name: 'MakeIcon',
    path: '/makeIcon',
    component: () => import('pages/plugin/makeIcon'),
    meta: {
      title: '制作图标',
      keepAlive: true
    }
  },
  {
    name: 'InputCode',
    path: '/inputCode',
    component: () => import('pages/plugin/inputCode'),
    meta: {
      title: '填写代码',
      keepAlive: true
    }
  },
  {
    name: 'DocEdit',
    path: '/docEdit',
    component: () => import('pages/plugin/docEdit'),
    meta: {
      title: '编辑文档',
      keepAlive: true
    }
  }
]
export default Plugin
